import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useAtom } from 'jotai/index';
import { useSearchParams } from 'react-router-dom';
import SmallDropdown from '../../../ui-kit/SmallDropdown';
import styles from '../css/index.module.scss';
import { LANGUAGES } from '../../../constants/languages';
import TickIcon from '../../../assets/icons/tickWhite.svg';
import useTranslations from '../../../hooks/useTranslations';
import useComponentVisible from '../../../hooks/useComponentVisible';
import { languagesListAtom } from '../../../atoms/globalAtoms';
import makeFirstUppercase from '../../../helpers/makeFirstUppercase';
import LocalStorageServices from '../../../services/LocalStorageServices';

function LanguagesDropdown({ setIsOverlayVisible }) {
  const { lang, setLang } = useTranslations();
  const [languagesList] = useAtom(languagesListAtom);
  const [searchParams, setSearchParams] = useSearchParams();

  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible();
  const onLanguageClick = () => {
    setIsComponentVisible(true);
  };

  const onLanguageSelect = (code) => {
    setIsComponentVisible(false);
    if (location.pathname === '/configurator' && searchParams.get('only_details') !== 'true') {
      const newParams = Object.fromEntries([...searchParams.entries()]);
      newParams.new_lang = code;
      setSearchParams(newParams, { replace: true });
    } else {
      setLang(code);
    }
  };

  useEffect(() => {
    setIsOverlayVisible(isComponentVisible);
  }, [isComponentVisible]);

  return (
    <>
      <SmallDropdown text={languagesList[lang]?.shortName || makeFirstUppercase(lang)} onClick={onLanguageClick} />
      <div
        ref={ref}
        className={classNames(
          styles.dropdown,
          styles.langDropdown,
          { [styles.dropdownVisible]: isComponentVisible },
        )}
      >
        {Object.keys(languagesList).map((key) => (
          <div
            key={key}
            className={classNames(
              styles.dropdownItem,
              styles.langDropdownItem,
              { [styles.langDropdownItemActive]: key === lang },
            )}
            onClick={() => onLanguageSelect(languagesList[key].code)}
          >
            <p className={styles.dropdownItemText}>{languagesList[key].name}</p>
            {key === lang && <img src={TickIcon} alt="V" className={styles.langDropdownTick} />}
          </div>
        ))}
      </div>
    </>
  );
}

export default LanguagesDropdown;
